import { render, staticRenderFns } from "./_backslider.vue?vue&type=template&id=52ec0212&"
import script from "./_backslider.vue?vue&type=script&lang=js&"
export * from "./_backslider.vue?vue&type=script&lang=js&"
import style0 from "./_backslider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../emtsrc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../emtsrc/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
installComponents(component, {VBottomNavigation,VCarousel,VCarouselItem})
